<template>
  <div>
    <b-row>
      <b-col cols="10">
        
         
        <p v-if="!collapse">{{dateAge(age)}}</p>
        
        <h6 class="text-truncate" v-if="!collapse">{{resultData.title}}</h6>&nbsp;
        <p v-if="resultData.analysis.keywordMatchesTotal > 0">


                        <b-badge  variant="danger" class="mr-2">Number Matched Keywords ({{resultData.analysis.keywordMatchesTotal}})</b-badge>
        </p>
        <p v-if="resultData.analysis.keywordMatchesTotal == 0">
          
                        <b-badge  variant="success" class="mr-2">No Number Matched Keywords</b-badge>
        </p>

        <p v-if="resultData.analysis.nlp && resultData.analysis.nlp.keywords">


                        <b-badge  variant="danger" class="mr-2">NLP Match</b-badge>
        </p>

        
      </b-col>
      <b-col cols="2" class="text-right">
        <button
          class="btn btn-outline-primary btn-sm"
          :aria-expanded="collapse ? 'true' : 'false'"
          aria-controls="collapse-1"
          @click="$emit('collapse-field')"
        >
          <font-awesome-icon :icon="collapse? 'minus' : 'plus'" />
        </button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import moment from "moment";

export default {
  name: "MenuButtons",
  data() {
    return {
      isLoading: false,
      currentSections: [],
      selectedSections: [],
      isFormPublished: false
    };
  },

  computed: {
    ...mapGetters(["selectedLanguage"]),
    ...mapState(["form1"])
  },
  watch: {},

  mounted() {
  },

  methods: {
    ...mapMutations(["TOGGLE_LOADER"]),

    toggleSetting() {
      this.$emit("toggle-field");
    },
    
    dateAge(value) {
      // // console.log(value);
      moment.updateLocale(moment.locale(), { invalidDate: "Age of article is unknown" });
      let localeData = moment.updateLocale("en", {
        relativeTime: {
          future: "in %s",
          past: "%s ago",
          s: "hello, a few seconds",
          ss: "%d seconds",
          m: "a minute",
          mm: "%d minutes",
          h: "an hour",
          hh: "%d hours",
          d: "a day",
          dd: "%d days",
          M: "a month",
          MM: "%d months",
          y: "a year",
          yy: "%d years"
        }
      });

      return moment(value).fromNow();
    }
  },
  props: {
    collapse: Boolean,
    resultData: Object,
    resultIndex: Number,
    age: String,
    keywords:Array,
    filtered: Boolean
    
  }
};
</script>
<style>
.custom-clone {
  min-height: 300px;
}
</style>

